module.exports = __webpack_public_path__ + "img/265-6b226b.png";